export default __webpack_public_path__ + "images/guarddiagram2.jpeg";